<section class="">
  <!-- Form -->
  <form [formGroup]="passwordForm" class="space-y-5">
    <!-- Old Password -->
    <div>
      <app-custom-input [label]="'Current Password'" [showAsteric]="true" [showLabel]="true"
        [placeholder]="'Enter current password'" type="password" formControlName="oldPassword"></app-custom-input>
      @if (passwordForm.get('oldPassword')?.invalid && (passwordForm.get('oldPassword')?.touched ||
      passwordForm.get('oldPassword')?.dirty)) {
      <div class="text-error text-xs mt-2">Current password is required.</div>
      }
    </div>

    <!-- New Password -->
    <div>
      <app-custom-input [label]="'New Password'" [showAsteric]="true" [showLabel]="true"
        [placeholder]="'Enter new password'" type="password" formControlName="password"></app-custom-input>
      @if (passwordForm.get('password')?.invalid && (passwordForm.get('password')?.touched ||
      passwordForm.get('password')?.dirty)) {
      <div class="text-error text-xs mt-2">
        @if (passwordForm.get('password')?.errors?.['required']) {
        New password is required.
        } @else if (passwordForm.get('password')?.errors?.['minlength']) {
        Password must be at least 6 characters long.
        }
      </div>
      }
    </div>

    <!-- Confirm Password -->
    <div>
      <app-custom-input [label]="'Confirm New Password'" [showAsteric]="true" [showLabel]="true"
        [placeholder]="'Confirm new password'" type="password"
        formControlName="passwordConfirmation"></app-custom-input>
      @if (passwordForm.get('passwordConfirmation')?.invalid && (passwordForm.get('passwordConfirmation')?.touched ||
      passwordForm.get('passwordConfirmation')?.dirty)) {
      <div class="text-error text-xs mt-2">
        @if (passwordForm.get('passwordConfirmation')?.errors?.['required']) {
        Please confirm your new password.
        }
      </div>
      }
      @if (passwordForm.errors?.['passwordMismatch'] && passwordForm.get('passwordConfirmation')?.touched) {
      <div class="text-error text-xs mt-2">Passwords do not match.</div>
      }
    </div>

    <!-- Submit Button -->
    <div class="pt-4">
      <app-primary-button [text]="'Change Password'" [isLoading]="isLoading"
        (onClickEvent)="onSubmit()"></app-primary-button>
    </div>
  </form>
</section>